<template>
	<Col>
		<h3 class="reg mb-2">Choose member or group</h3>
		<AppSelect
			dense
			outlined
			hide-details
			item-value="id"
			item-text="name"
			v-model="selectedItem"
			:items="membersAndGroups"
			:menu-props="{ bottom: true, offsetY: true }"
		>
			<template v-slot:selection="{ item }">
				<UserSelectComboboxItem class="selected-item" :size="30" :item="item" />
			</template>
			<template v-slot:item="{ item }">
				<UserSelectComboboxItem :item="item" />
			</template>
		</AppSelect>
	</Col>
</template>
<script>
import { teamMembers } from '@/store/modules/account/getters';
import { groups } from '@/store/modules/accountGroups/getters';
import { getGroups } from '@/store/modules/accountGroups/actions';
import { mapActionsShorthand, mapGettersShorthand } from '@/store/utils/mappers';
import UserSelectComboboxItem from '@/components/dialogs/ShareModuleDialog/UserSelectComboboxItem.vue';
export default {
	name: 'CustomizeNotificationAvatarIcon',
	components: {
		UserSelectComboboxItem,
	},
	props: {
		selectedEntityId: { type: Number },
	},
	computed: {
		...mapGettersShorthand({ groups, teamMembers }),
		membersAndGroups() {
			return [
				...this.teamMembers,
				...this.groups.map((group) => ({ ...group, isGroup: true })),
				//
			].filter(this.getItemAvatar);
		},
	},
	methods: {
		...mapActionsShorthand({ getGroups }),
		getItemAvatar(item) {
			return item.google_avatar || item.avatar;
		},
	},
	async created() {
		await this.getGroups();
		if (this.selectedEntityId) {
			this.selectedItem = this.selectedEntityId;
		}
	},
	data() {
		return {
			selectedItem: null,
		};
	},
	watch: {
		selectedItem: {
			handler(val) {
				const item = this.membersAndGroups.find((item) => item.id === val);
				const icon = this.getItemAvatar(item);
				this.$emit('change-icon', { icon, entity_id: item.id });
			},
		},
	},
};
</script>
<style scoped lang="scss">
::v-deep(.selected-item) {
	.user-name {
		overflow: hidden;
		display: -webkit-box;
		text-overflow: ellipsis;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 1; // num of rows to break
	}
}
</style>
